/**
 * Document Helper - utilities for document display and formatting
 */

// Constants for document processing
const FILE_PREFIX = 'FILE:';
const TIMESTAMP_PATTERN = /_\d{14,20}$/;

/**
 * Checks if a document is an uploaded file based on its external link
 * @param {string} externalLink - The external link string
 * @returns {boolean} True if the document is an uploaded file
 */
export const isUploadedDocument = externalLink => {
  if (!externalLink) return false;
  return externalLink.startsWith(FILE_PREFIX);
};

/**
 * Formats the display link for documents
 * For uploaded documents: removes 'FILE:' prefix and timestamp suffix
 * For regular URLs: returns as-is
 *
 * @param {string} externalLink - The external link string
 * @returns {string} Formatted display link
 */
export const formatDocumentLink = externalLink => {
  if (!externalLink) return '';

  if (isUploadedDocument(externalLink)) {
    const fullName = externalLink.substring(FILE_PREFIX.length).trim();
    return fullName.replace(TIMESTAMP_PATTERN, '');
  }

  return externalLink;
};
